<template>
  <div>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息</el-breadcrumb-item>
        <el-breadcrumb-item>个人信息完善</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input type="text" v-model="ruleForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobiles">
          <el-input type="text" maxlength="11" :disabled="(ruleForm.mobiles2==null||ruleForm.mobiles2=='')?false:true" v-model="ruleForm.mobiles"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input maxlength="20" v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>




  </div>
</template>
  
<script>
import { checkMobiles, checkEmail } from '@/components/work/until/vaildate.js'
export default {
  created() {
    this.getUserByID()
  },
  data() {
    var studentID = (rule, value, callback) => {
      let reg = /^[0-9]{9}$/;
      if (!reg.test(value)) {
        callback(new Error("由九位数字组成"))
      } else {
        callback();
      }
    }
    return {
      teacherList: [],
      classList: [],
      ruleForm: {
        mobiles: '',
        mobiles2:'',
        name: '',
        studentID: '',
        userid: '',
        tutorid: '',
        email: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        mobiles: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobiles }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail }
        ]
      }

    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let config = { headers: { "Content-Type": "application/json" } };
          const formData = new FormData()
          formData.append('userid', JSON.parse(localStorage.getItem('user')).userid)
          formData.append("name", this.ruleForm.name)
          formData.append("mobiles", this.ruleForm.mobiles)
          formData.append("classId", this.ruleForm.classId)
          formData.append("email", this.ruleForm.email)
          console.log(this.ruleForm.teacherTypes)
          this.axios.post("/user/updateUserInfo", formData, config)
            .then(resp => {
              if (resp.data.status == 1) {
                this. getUserByID()
                this.$message.success("完善成功")
              } else {
                this.$message.error("失败")
              }
            }).catch((err) => {
              alert("出错了")
            })
        }
      })
    },
    getUserByID() {
      this.axios.post("/user/getUserByID", "userid=" + JSON.parse(localStorage.getItem('user')).userid)
        .then(resp => {
          if (resp.data.status == 1) {
            console.log(resp.data.result)
            this.ruleForm.name = resp.data.result.name
            this.ruleForm.mobiles = resp.data.result.mobiles
            this.ruleForm.mobiles2 = resp.data.result.mobiles
            if (resp.data.result.email != '') {
              this.ruleForm.email = resp.data.result.email
            }


          }
        })
      this.axios.post("/user/getUser", 'type=5')
        .then(res => {
          if (res.data.status == 1) {
            this.teacherList = res.data.result
          }
        })

      this.axios.post("/classGrade/getClassGrade")
        .then(res => {
          if (res.data.status == 1) {
            console.log(res.data.result)
            this.classList = res.data.result

          }
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }

  }
}
</script>
  
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/work/instructor/InstrutorEVPI.vue